import React, { Component, Fragment } from 'react';
import 'react-dates/initialize';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import { connect } from 'react-redux';
import { setDate, resetFlights } from '../../../actions/bookingActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper';

class Calendar extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      focusedInput: props.autoFocusEndDate ? 'endDate' : 'startDate',
      startDate: props.initialStartDate,
      endDate: props.initialEndDate,
      oneWay: true
    };
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, 'content.calendar.' + key);
  }

  componentDidMount() {
    moment.updateLocale('en', {
      longDateFormat: {
        L: 'DD.MM.YYYY'
      }
    });
    this.setState({
      startDate: this.props.startDate.value,
      endDate: this.props.endDate.value
    });
  }

  onFocusChangeHandler = (focusedInput) => {
    if (focusedInput === null) {
      this.setState({ focusedInput: 'startDate' });
    } else {
      this.setState({ focusedInput });
      return;
    }
  }

  onDatesChangeHandler = ({ startDate, endDate }) => {
    var oneWayTranslated = this.trans('oneWay');
    const { setDate } = this.props;
    const startDateFormated = moment(startDate).format('DD.MM.YYYY');
    const endDateFormated = moment(endDate).format('DD.MM.YYYY') === 'Invalid date' ? oneWayTranslated : moment(endDate).format('DD.MM.YYYY');

    if (this.props.startDate.value !== startDate.value || this.props.endDate.value !== endDate.value) {
      this.props.resetFlights();
    }
    if (this.state.oneWay) {
      this.setState({ startDate, endDate }, () => {
        setDate('startDate', startDate, startDateFormated);
        setDate('endDate', endDate, endDateFormated);
        if (this.state.endDate !== null) {
          this.setState({ oneWay: false });
        } else {
          this.setState({ oneWay: true });
        }
      });
    } else {
      this.setState({ startDate, endDate: null, oneWay: true }, () => {
        setDate('startDate', startDate, startDateFormated);
        setDate('endDate', this.state.endDate, oneWayTranslated);
      });
    }
  }

  handleClick = () => {
    this.props.closeModal();
  }

  render() {
    const { focusedInput, startDate, endDate } = this.state;
    return (
      <Fragment >
        <div className="booking__calendar">
          <DateRangePicker
            startDate={startDate}
            startDateId='your_unique_start_date_id'
            endDate={endDate}
            endDateId='your_unique_end_date_id'
            onDatesChange={this.onDatesChangeHandler}
            focusedInput={focusedInput}
            onFocusChange={this.onFocusChangeHandler}
            orientation='vertical'
            hideKeyboardShortcutsPanel={true}
            firstDayOfWeek={1}
            daySize={30}
            monthFormat='MMMM'
            displayFormat={() => moment.localeData().longDateFormat('L')}
            navPrev={<FontAwesomeIcon icon={['fas', 'angle-up']} />}
            navNext={<FontAwesomeIcon icon={['fas', 'angle-down']} />}
            readOnly={true}
          />
          <div className="booking__calendar-button">
            <button className="button button--outline button--expand" onClick={this.handleClick}>{this.trans('confirm')}</button>
          </div>
        </div>
      </Fragment>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    startDate: state.booking.startDate,
    endDate: state.booking.endDate
  };
};

export default connect(mapStateToProps, { setDate, resetFlights })(Calendar);
